import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Playlist from './playlist-model'
import {
  CreatePlaylistAsync,
  DeletePlaylistAsync,
  LoadPlaylistsAsync,
} from './playlist-thunk'
const initialState: playlistSliceState = {
  playlist: [],
  selected_playlist: '',
  is_loading_playlist: false,
  is_creating_playlist: false,
  is_deleting_playlist: false,
}
export interface playlistSliceState {
  playlist: Playlist[]
  selected_playlist?: string
  is_loading_playlist: boolean
  is_creating_playlist: boolean
  is_deleting_playlist: boolean
}
export const playlistSlice = createSlice({
  name: 'playlist',
  initialState,
  reducers: {
    setSelectedplaylist: (state, action) => {
      state.selected_playlist = action.payload
    },
    clearStateplaylist: (state) => {
      state.playlist = []
      state.is_loading_playlist = false
      state.is_creating_playlist = false
      state.is_deleting_playlist = false
    },
    mergeplaylist: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_playlist = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.playlist = merge(state.playlist, payload) as any
        }
      }
    },

    add_playlist: (state, action) => {
      if (action.payload) {
        state.playlist = [...state.playlist, action.payload]
      }
    },
    set_playlist: (state, action) => {
      let { key, value, id } = action.payload
      state.playlist = state.playlist.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPlaylistsAsync.pending, (state) => {
      state.is_loading_playlist = true
    })
    builder.addCase(LoadPlaylistsAsync.fulfilled, (state, action) => {
      state.is_loading_playlist = false
      if (action.payload) {
        state.playlist = action.payload
      }
    })
    builder.addCase(LoadPlaylistsAsync.rejected, (state) => {
      state.is_loading_playlist = false
    })
    builder.addCase(CreatePlaylistAsync.pending, (state) => {
      state.is_creating_playlist = true
    })
    builder.addCase(CreatePlaylistAsync.fulfilled, (state) => {
      state.is_creating_playlist = false
    })
    builder.addCase(CreatePlaylistAsync.rejected, (state) => {
      state.is_creating_playlist = false
    })
    builder.addCase(DeletePlaylistAsync.pending, (state) => {
      state.is_deleting_playlist = true
    })
    builder.addCase(DeletePlaylistAsync.fulfilled, (state, action) => {
      state.is_deleting_playlist = false
      if (state.playlist) {
        state.playlist = state.playlist.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePlaylistAsync.rejected, (state) => {
      state.is_deleting_playlist = false
    })
  },
})

export const {
  clearStateplaylist,
  setSelectedplaylist,
  set_playlist,
  mergeplaylist,
  add_playlist,
} = playlistSlice.actions

export const get_playlist =
  (id?: string) =>
  (state: {
    playlist: {
      playlist: Playlist[]
    }
  }): Playlist | null => {
    let temp = state?.playlist?.playlist?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.playlist?.playlist[0] || null
  }
export const get_selected_playlist = (state: {
  playlist: playlistSliceState
}): Playlist | null => {
  let id = state?.playlist?.selected_playlist
  let temp = state?.playlist?.playlist?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_playlist = (state: {
  playlist: {
    playlist: Playlist[]
  }
}): Playlist[] => {
  let temp = state?.playlist?.playlist
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_playlist_busy = (state: { playlist: playlistSliceState }) => {
  return (
    state?.playlist.is_deleting_playlist ||
    state?.playlist.is_loading_playlist ||
    state?.playlist.is_creating_playlist
  )
}
export const is_deleting_playlist_busy = (state: {
  playlist: playlistSliceState
}) => {
  return state?.playlist.is_deleting_playlist
}
export const is_loading_playlist_busy = (state: {
  playlist: playlistSliceState
}) => {
  return state?.playlist.is_loading_playlist
}
export const is_creating_playlist_busy = (state: {
  playlist: playlistSliceState
}) => {
  return state?.playlist.is_creating_playlist
}

export default playlistSlice.reducer
